const noop = ()=>null;
export default noop;

//# sourceMappingURL=noop.js.map